module.exports = __webpack_public_path__ + "static/media/mongoDB.58da2127.svg";